import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

export const obtenerEventosFecha = async (fecha) => {

    let fechaInicio = new Date(fecha).setHours(0, 1)
    let fechaFin = new Date(fecha).setHours(23, 59)

    let wheres = [where('fecha', '>=', fechaInicio), where('fecha', '<=', fechaFin), where('estado', '==', 'Publicado')]

    let dox = await obtenerColWheres({col: 'eventos', wheres: wheres})

    return dox.data


}